import React from "react";
import Navigation from "./Navigation";
import "../App.css";

const Header = () => (
  <header className="header">
    <Navigation />
  </header>
);

export default Header;
